/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Button, Typography } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "../../../components/ui/dialog";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import {
  timeSheetUpdate
} from "../../../services/apiservices/timesheets";
import dayjs from "dayjs";
import moment from "moment-timezone";
import styles from "../dashboard.module.scss";
import { useMediaQuery } from "@mui/material";

const getCompletedBreakMs = (breakTimes) => {
  if (!breakTimes) return 0;

  return Object.values(breakTimes).reduce((total, br) => {
    if (!br?.startTime || !br?.endTime) return total;

    const start = dayjs.unix(br.startTime.seconds);
    const end = dayjs.unix(br.endTime.seconds);

    return total + Math.max(0, end.diff(start));
  }, 0);
};

const hasCompletedBreak = (breakTimes) => {
  if (!breakTimes) return false;

  return Object.values(breakTimes).some(
    (br) => br?.startTime && br?.endTime
  );
};

const formatMsToHM = (ms) => {
  if (!ms || ms <= 0) return "0";

  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours && minutes) return `${hours}h ${minutes}min`;
  if (hours) return `${hours}h`;
  return `${minutes}min`;
};


export const ShiftStatus = (props) => {
  const [selectedShift, setSelectedShift] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const getShiftData = (shiftData, shift) => {
    const result = [];
    for (let shiftObj in shiftData) {
      for (let element in shiftData[shiftObj]) {
        const title = shiftData[shiftObj][element]["title"];
        if (title !== "Opentasks") {
          result.push({
            value: title,
            label: title,
            data: shiftData[shiftObj],
            shiftId: shiftObj,
          });
        }
      }
    }
    if (result?.length === 0 || shift === "No Shift") {
      result?.push({
        value: "No Shift",
        label: "No Shift",
      });
    }
    return result;
  };

  const shiftDetails = getShiftData(
    props.appointment?.clientDetails?.shiftData,
    props?.appointment?.shift
  )?.filter(
    (obj, index, self) =>
      index === self?.findIndex((el) => el?.value === obj?.value)
  );

  const onSelectShift = async (event) => {
    const {
      target: { value },
    } = event;

    const selShiftData = shiftDetails?.find((ele) => ele.value === value);

    const apptData = {
      ...props.appointment,
      shiftId: selShiftData.shiftId,
      tasks: selShiftData.data,
    };
    delete apptData.clientDetails;
    delete apptData.id;

    setIsLoading(true);
    timeSheetUpdate(
      props.appointment.id,
      apptData,
      (result) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      },
      (errr) => {
        props?.setShow(false);
        setIsLoading(false);
        props.refreshData();
      }
    );

    setSelectedShift(value);
  };

  useEffect(() => {
    setSelectedShift(() => {
      if (
        props.appointment?.tasks &&
        Object.keys(props.appointment?.tasks).length > 0
      ) {
        for (let ele in props.appointment?.tasks) {
          return props.appointment?.tasks[ele]["title"];
        }
      } else {
        return (
          <div>
            {"----"} <span style={{ color: "red" }}>{`(0 Tasks)`}</span>
          </div>
        );
      }
    });
  }, [props.appointment]);

  // if (props.isEdit) {
  return (
    <>
      {isLoading ? (
        <>
          <CircularProgress size={20} />
        </>
      ) : (
        <div className="clientsingleSelect">
          <SingleSelect
            label="Select Shift"
            value={
              props?.appointment?.shift === "No Shift"
                ? "No Shift"
                : selectedShift
            }
            className="field"
            name="selectedShift"
            onChange={(e) => {
              if (props?.appointment?.checkInDateTime) {
                setShowDialog(true);
                return;
              }
              if (!(props?.appointment?.shift === "No Shift")) {
                onSelectShift(e);
              }
            }}
            options={shiftDetails}
            disabled={props?.appointment?.shift === "No Shift"}
            trimShift={true}
          />
        </div>
      )}

      {showDialog && (
        <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
          <DialogContent closeButton={false}>
            <DialogTitle className="mt-5 dark:text-white border-b pb-10">
              Shift Change Not Allowed
            </DialogTitle>
            <p className="font-medium text-[16px] dark:text-white mb-10 mt-5">
              This shift cannot be changed because work has started.
            </p>
            <div className="d-flex flex-justify-center">
              <Button
                style={{
                  backgroundColor: "#16A34A",
                  color: "white",
                  maxWidth: "250px",
                }}
                variant="default"
                onClick={() => setShowDialog(false)}
                autoFocus
              >
                Close
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
  // } else {
  //   return (
  //     <>
  //       {selectedShift}
  //     </>
  //   );
  // }
};

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export const ClockInOut = ({
  cellData,
  show,
  checkInDateTime,
  setCheckInDateTime,
  checkOutDateTime,
  setCheckOutDateTime,
  setDurationString,
  durationString,
  breakDurationString,
  setBreakDurationString
}) => {
  const checkInUnixTimestamp = cellData?.checkInDateTime?.seconds;
  const checkOutUnixTimestamp = cellData?.checkOutDateTime?.seconds;
  const isMobile = useMediaQuery('(max-width:767px)');

  const timezone = cellData?.calendarTimezone
    ? cellData?.calendarTimezone
    : "America/New_York";
  useEffect(() => {
    if (checkInUnixTimestamp) {
      const checkIn = dayjs.unix(checkInUnixTimestamp).tz(timezone);
      if (checkIn && checkIn.isValid()) {
        const formattedCheckInDateTime = checkIn.format("hh:mm A");
        setCheckInDateTime(formattedCheckInDateTime);
      } else {
        console.error("Invalid date/time");
      }
    } else {
      setCheckInDateTime(null);
    }
  }, [checkInUnixTimestamp]);

  useEffect(() => {
    if (checkOutUnixTimestamp) {
      const checkOut = dayjs.unix(checkOutUnixTimestamp).tz(timezone);
      if (checkOut && checkOut.isValid()) {
        const formattedCheckOutDateTime = checkOut.format("hh:mm A");
        setCheckOutDateTime(formattedCheckOutDateTime);
      } else {
        console.error("Invalid date/time");
      }
    } else {
      setCheckOutDateTime(null);
    }
  }, [checkOutUnixTimestamp]);

  useEffect(() => {
    let finalDuration = "—";
    let breakDuration = null;       
    let workedMs = 0;

    const isUserUpdated =
      checkInDateTime &&
      checkOutDateTime &&
      (checkInDateTime !==
        dayjs
          .unix(cellData?.checkInDateTime?.seconds)
          .tz(timezone)
          .format("hh:mm A") ||
        checkOutDateTime !==
          dayjs
            .unix(cellData?.checkOutDateTime?.seconds)
            .tz(timezone)
            .format("hh:mm A"));

    const formatTimeDifference = (hours, minutes) => {
      if (hours === 0 && minutes === 0) {
        return "0";
      } else {
        const absHours = Math.abs(hours);
        const absMinutes = parseInt(Math.abs((minutes * 100) / 60), 10);
        return `${absHours}.${absMinutes.toString().padStart(2, "0")}`;
      }
    };

    if (checkInDateTime && checkOutDateTime) {
      let checkIn = dayjs(checkInDateTime, "hh:mm A");
      let checkOut = dayjs(checkOutDateTime, "hh:mm A");

        if (checkOut.isBefore(checkIn)) {
          checkOut = checkOut.add(1, "day");
        }

        const diff = checkOut.diff(checkIn);
        workedMs = checkOut.diff(checkIn);
        // const dur = dayjs.duration(diff);
        // const totalMinutes = dur.asMinutes();

        // const absHours = Math.floor(totalMinutes / 60);
        // const absMinutes = Math.round(totalMinutes % 60);
        // finalDuration = formatTimeDifference(absHours, absMinutes);

      } else if (
        cellData?.checkInDateTime?.seconds &&
        cellData?.checkOutDateTime?.seconds
      ) {
        const checkIn = dayjs.unix(cellData?.checkInDateTime?.seconds).tz(timezone);
        const checkOut = dayjs.unix(cellData?.checkOutDateTime?.seconds).tz(timezone);

        if (checkIn.isValid() && checkOut.isValid()) {
          workedMs = checkOut.diff(checkIn);
        }
        // if (checkIn.isValid() && checkOut.isValid()) {
        //   const duration = dayjs.duration(checkOut.diff(checkIn));
        //   const totalMinutes = duration.asMinutes();

        //   const absHours = Math.floor(totalMinutes / 60);
        //   const absMinutes = Math.round(totalMinutes % 60);
        //   finalDuration = formatTimeDifference(absHours, absMinutes);
        // }
      }

      if (workedMs > 0 && hasCompletedBreak(cellData?.breakTimes)) {
        const breakMs = getCompletedBreakMs(cellData.breakTimes);
        workedMs = Math.max(0, workedMs - breakMs);
        breakDuration = formatMsToHM(breakMs);
      }

      if (workedMs > 0) {
        const totalMinutes = Math.floor(workedMs / 60000);
        const absHours = Math.floor(totalMinutes / 60);
        const absMinutes = totalMinutes % 60;
        finalDuration = formatTimeDifference(absHours, absMinutes);
      }

    setDurationString(finalDuration);
    setBreakDurationString(breakDuration);
  }, [
    checkInDateTime,
    checkOutDateTime,
    cellData?.checkInDateTime?.seconds,
    cellData?.checkOutDateTime?.seconds,
    cellData?.breakTimes,
    timezone,
  ]);

  return (
    <div className="flex flex-col p-18 bg-white dark:bg-[#1A1F2C]">
      <div className="flex flex-col flex-start mb-10">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Typography
            variant="h10"
            component="label"
            htmlFor="time-picker"
            className="font-bold text-center text-[#020817] dark:text-white"
          >
            Check-In Time
          </Typography>

          <TimePicker
            ampm={true}
            value={checkInDateTime ? dayjs(checkInDateTime, "hh:mm A") : null}
            onChange={(time) =>
              setCheckInDateTime(time ? time.format("hh:mm A") : null)
            }
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: "hh:mm aa",
                InputLabelProps: { shrink: true },
                InputProps: {
                  sx: {
                    height: "40px",
                    width: isMobile ? "300px" : "350px",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <div className="flex flex-col flex-start">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Typography
            variant="h10"
            component="label"
            htmlFor="time-picker"
            className="font-bold text-center text-[#020817] dark:text-white"
          >
            Check-Out Time
          </Typography>
          <TimePicker
            value={checkOutDateTime ? dayjs(checkOutDateTime, "hh:mm A") : null}
            onChange={(time) =>
              setCheckOutDateTime(time ? time.format("hh:mm A") : null)
            }
            ampm={true}
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: "hh:mm aa",
                InputLabelProps: { shrink: true },
                InputProps: {
                  sx: {
                    height: "40px",
                    width: isMobile ? "300px" : "350px",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <div className="flex flex-wrap items-center mt-15">
        <div className="mv-5">
          <span className="text-gray-500 dark:text-gray-300">Check In: </span>
          <span className="text-[#020817] dark:text-white text-sm font-medium">
            {!cellData?.checkInUpdatedBy ? (
              <a
                className={`${styles.timeZone} underline dark:text-white`}
                target="_blank"
                rel="noopener noreferrer"
                href={`https://maps.google.com/?q=${cellData?.location?.lat},${cellData?.location?.lng}`}
              >
                {cellData?.checkInDateTime
                  ? moment
                      .unix(cellData?.checkInDateTime?.seconds)
                      .tz(timezone)
                      .format("h:mm a")
                  : "---"}
              </a>
            ) : cellData?.checkInDateTime ? (
              moment
                .unix(cellData?.checkInDateTime?.seconds)
                .tz(timezone)
                .format("h:mm a")
            ) : (
              "---"
            )}
          </span>
        </div>

        <div className="mv-5 ml-20">
          <span className="text-gray-500 dark:text-gray-300">Check Out: </span>
          <span className="text-[#020817] dark:text-white text-sm font-medium">
            {!cellData?.checkOutUpdatedBy ? (
              <a
                className={`${styles.timeZone} underline dark:text-white`}
                target="_blank"
                rel="noopener noreferrer"
                href={`https://maps.google.com/?q=${cellData?.shiftend_location?.lat},${cellData?.shiftend_location?.lng}`}
              >
                {cellData?.checkOutDateTime
                  ? moment
                      .unix(cellData?.checkOutDateTime?.seconds)
                      .tz(timezone)
                      .format("h:mm a")
                  : "---"}
              </a>
            ) : cellData?.checkOutDateTime ? (
              moment
                .unix(cellData?.checkOutDateTime?.seconds)
                .tz(timezone)
                .format("h:mm a")
            ) : (
              "---"
            )}
          </span>
        </div>

        <div className={isMobile ? "mv-5" :"mv-5 ml-20"}>
          <span className="text-gray-500 dark:text-gray-300">
            Total Hours:{" "}
          </span>
          <span className="text-[#020817] dark:text-white text-sm font-medium">
            {durationString}
          </span>
        </div>

        {breakDurationString && (
          <div className={isMobile ? "mv-5 ml-20" : "mv-5"}>
            <span className="text-gray-500 dark:text-gray-300">
              Break Time:{" "}
            </span>
            <span className="text-[#020817] dark:text-white text-sm font-medium">
              {breakDurationString}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};